import { render, staticRenderFns } from "./files.vue?vue&type=template&id=26cfcdfc&scoped=true"
import script from "./files.vue?vue&type=script&lang=js"
export * from "./files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cfcdfc",
  null
  
)

export default component.exports